// utils/auth/abilities.ts
import { canonicalGardianProfile, ERole } from './e_roles'
import {
  canAccessAdminHubRoleSet,
  canAdminTagsRoleSet,
  canUseTechToolsRoleSet,
  canViewRoleMatrixPageRoleSet,
} from './roleCapabilityMatrix'

export function isLegacyAdmin(roles: string[]): boolean {
  return roles.includes(ERole.ADMIN)
}

export function isSuperAdmin(roles: string[]): boolean {
  return roles.some((role) => canonicalGardianProfile(role) === ERole.SUPER_ADMIN)
}

export function isDeveloper(roles: string[]): boolean {
  return roles.includes(ERole.DEVELOPER)
}

export function isManager(roles: string[]): boolean {
  return roles.includes(ERole.MANAGER)
}


export function canAccessAdmin(roles: string[]): boolean {
  return canAccessAdminHubRoleSet(roles)
}

export function canViewRoleMatrixPage(roles: string[]): boolean {
  return canViewRoleMatrixPageRoleSet(roles)
}

export function canAdminTags(roles: string[]): boolean {
  return canAdminTagsRoleSet(roles)
}

/** Sites : super-admin et développeur (aligné sur SitePolicy backend). */
export function canAdminSites(roles: string[]): boolean {
  return isSuperAdmin(roles) || isDeveloper(roles)
}

export function canUseTechTools(roles: string[]): boolean {
  return canUseTechToolsRoleSet(roles)
}

/**
 * Mode édition organigramme : super-admin, manageur applicatif, ou admin OIDC avec au moins une direction dans son périmètre (rattachement orga).
 * `directionAdminDirLibs` : renvoyé par GET /v1/me (vide si aucune direction de rattachement admin).
 */
export function canUseOrganigrammeEditMode(
  roles: string[],
  directionAdminDirLibs: string[] = []
): boolean {
  if (isSuperAdmin(roles)) {
    return true
  }
  if (isDeveloper(roles)) {
    return true
  }
  if (isManager(roles)) {
    return true
  }
  if (isLegacyAdmin(roles)) {
    return directionAdminDirLibs.length > 0
  }
  return false
}

